import { useAtomValue } from 'jotai';
import { Popover } from '@headlessui/react';

// Types
import type { PopoverChildrenProps } from '@/components/base/Popover';
import type { InputProps } from '@/components/base/Input';

// Atoms
import { datepickerInputValueAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';

// Components
import Input from '@/components/base/Input';

type DatepickerInputProps = Pick<PopoverChildrenProps, 'setReferenceElement'> & InputProps;

export function DatepickerInput({ setReferenceElement, ...restProps }: DatepickerInputProps) {
    const datepickerValue = useAtomValue(datepickerInputValueAtom);

    return (
        <Popover.Button
            data-testid="datepicker-input-button"
            className="w-full rounded-md focus:ring-offset-0"
            ref={setReferenceElement}>
            <Input
                data-testid="datepicker-input"
                defaultValue={datepickerValue}
                key={datepickerValue}
                inputStyle="datepicker"
                readOnly
                {...restProps}
            />
        </Popover.Button>
    );
}
